export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center space-y-6">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full whitespace-nowrap">
            加入我们
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            投稿爆料
          </h2>
          <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
            你有独家<strong>吃瓜资源</strong>要分享？发现了不为人知的<strong>最新黑料</strong>？<strong>17吃瓜网</strong>欢迎每一位瓜友的投稿与爆料。我们承诺严格保护爆料人隐私，所有信息均经多源核实后发布。加入<strong>17一起吃瓜网</strong>的内容共创社区，让你的发现被百万瓜友看到！
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-4">
            <div className="flex items-center gap-3 text-sm text-foreground-600">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div className="text-left">
                <p className="font-medium text-foreground-900">投稿邮箱</p>
                <p className="text-xs">tips@17chigua.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3 text-sm text-foreground-600">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-500">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div className="text-left">
                <p className="font-medium text-foreground-900">官方微信</p>
                <p className="text-xs">17吃瓜小助手</p>
              </div>
            </div>
            <div className="flex items-center gap-3 text-sm text-foreground-600">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500">
                <i className="ri-chat-3-line text-lg"></i>
              </div>
              <div className="text-left">
                <p className="font-medium text-foreground-900">在线留言</p>
                <p className="text-xs">24小时内回复</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}